// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d6418621","175":"673b7821","252":"dae7f2c9","505":"cec70fb0","533":"96d1b87c","559":"6d0fa36e","678":"7b59ece2","753":"9fa8586a","824":"60ff6d5a","979":"745781fc"}[chunkId] + ".chunk.js";
};